import ImgixClient from '@imgix/js-core'

export default function () {
  return new ImgixClient({
    domain: 'assets.nextory.com',
  })
}
